/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef } from 'react';
import * as LR from '@uploadcare/blocks';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isFunction from 'lodash/isFunction';
import { MAX_LOCAL_FILE_SIZE_BYTES, UPLOAD_CARE_SOURCE_LIST_DEFAULT, UPLOAD_CARE_WIDGET_TYPE } from './UploadCareWidget.constants';
import { getFileSelectionMessage, getUploadCareConfigSettings, getFileUploaderConfigSettings } from './UploadCareWidget.utils';
import { FileObjectProptype } from '../../types/FormField.types';
import './UploadCareWidget.less';
LR.registerBlocks(LR);
var defaultProps = {
  publicKey: '',
  maxLocalFileSizeBytes: MAX_LOCAL_FILE_SIZE_BYTES,
  multiple: true,
  sourceList: UPLOAD_CARE_SOURCE_LIST_DEFAULT,
  type: UPLOAD_CARE_WIDGET_TYPE.REGULAR,
  files: [],
  isReset: false
};
function UploadCareWidget(_ref) {
  var name = _ref.name,
    id = _ref.id,
    publicKey = _ref.publicKey,
    maxLocalFileSizeBytes = _ref.maxLocalFileSizeBytes,
    multiple = _ref.multiple,
    sourceList = _ref.sourceList,
    onFileChange = _ref.onFileChange,
    files = _ref.files,
    type = _ref.type,
    isReset = _ref.isReset;
  var fieldId = "".concat(id, "-").concat(name);
  var uploadCareContextName = "upload-care-file-uploader-".concat(fieldId);
  var uploadCareProviderRef = useRef(null);
  var uploadCareConfig = getUploadCareConfigSettings({
    ctxName: uploadCareContextName,
    publicKey: publicKey,
    maxLocalFileSizeBytes: maxLocalFileSizeBytes,
    sourceList: sourceList,
    multiple: multiple
  });
  var fileUploaderConfig = getFileUploaderConfigSettings({
    ctxName: uploadCareContextName
  });
  var ctxProviderSelector = "lr-upload-ctx-provider[ctx-name=\"".concat(uploadCareContextName, "\"]");
  var totalFiles = files.length;
  if (_isEmpty(publicKey)) {
    return null;
  }
  function resetContextFiles() {
    var ctxProvider = uploadCareProviderRef.current;
    if (ctxProvider && _isFunction(ctxProvider.removeAllFiles)) {
      ctxProvider.removeAllFiles();
    }
  }
  useEffect(function () {
    var handleFileChangeEvent = function handleFileChangeEvent(e) {
      var uploadedFiles = _get(e, 'detail.successEntries', []);
      onFileChange(uploadedFiles);
    };
    var ctxProvider = document.querySelector(ctxProviderSelector);
    if (_isEmpty(ctxProvider)) return null;
    ctxProvider.addEventListener('change', handleFileChangeEvent);
    return function () {
      ctxProvider.removeEventListener('change', handleFileChangeEvent);
    };
  }, []);
  useEffect(function () {
    if (isReset) {
      resetContextFiles();
    }
  }, [isReset]);
  return /*#__PURE__*/React.createElement("div", {
    className: "upload-care-widget"
  }, /*#__PURE__*/React.createElement("lr-config", uploadCareConfig), type === UPLOAD_CARE_WIDGET_TYPE.REGULAR && /*#__PURE__*/React.createElement("lr-file-uploader-regular", fileUploaderConfig), type === UPLOAD_CARE_WIDGET_TYPE.MINIMAL && /*#__PURE__*/React.createElement("lr-file-uploader-minimal", fileUploaderConfig), /*#__PURE__*/React.createElement("lr-upload-ctx-provider", {
    "ctx-name": uploadCareContextName,
    ref: uploadCareProviderRef
  }), totalFiles > 0 && /*#__PURE__*/React.createElement("span", {
    className: "file-uploaded-message"
  }, getFileSelectionMessage(totalFiles)));
}
UploadCareWidget.defaultProps = defaultProps;
export default UploadCareWidget;